import { render } from "./FieldSuggest.vue?vue&type=template&id=12d78933&lang=pug"
import script from "./FieldSuggest.vue?vue&type=script&lang=js"
export * from "./FieldSuggest.vue?vue&type=script&lang=js"

import "./FieldSuggest.vue?vue&type=style&index=0&id=12d78933&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__